export const DefaultPaginationSettings = {
    ROW_HEIGHT: 50,
    ROWS_PER_PAGE: 10,
    ROWS_PER_PAGE_OPTIONS: [10, 20, 50, 100]
}